define(function(require){
    'use strict';

    /*
     * Подключаем скрипты необходимые для плагина
     */
    var _ = require('underscore');
    var ModalsFactory   = require('modals/factory');
    var notie = require('notie');
    notie.alertHide();

    // Алерты про баны/модерацию/верификацию: скрытие ПОСТОЯННОЕ (localStorage, per-account).
    // Если клиент закрыл такой алерт — больше не показываем (смену статуса он узнаёт по
    // SMS/Telegram). В отличие от tariff/balance — те остаются (важные, не глушим навсегда).
    var PERSIST_ALERTS = ['fraud', 'mtt_moderation', 'telephony_locked', 'not_verified',
        'mtt_person_incomplete', 'mtt_org_incomplete', 'mtt_ip_incomplete',
        'mtt_rejected', 'mtt_revoked', 'mtt_review_pending'];
    function _acctId() {
        try { return String(app.Models.User.get('id') || ''); } catch (e) { return ''; }
    }
    function _persistKey(id) { return 'LPT_alert_off_' + _acctId() + '_' + id; }
    function _isPersist(id)  { return !!id && PERSIST_ALERTS.indexOf(id) !== -1; }
    function _isDismissed(id) {
        try { return localStorage.getItem(_persistKey(id)) === '1'; } catch (e) { return false; }
    }
    function _markDismissed(id) {
        if (!_isPersist(id)) { return; }
        try { localStorage.setItem(_persistKey(id), '1'); } catch (e) {}
    }

    return {
        firstTime: true,
        inQueue: [],

        danger: function (message, duration, options) {
            // alert() вернёт false, если алерт постоянно скрыт — тогда НЕ блокируем скролл
            if (this.alert('error', message, duration, options) === false) { return; }
            this.disableScroll();
            this.scrollDisabled = true;
        },

        success: function (message, duration, options) {
            this.alert('success', message, duration, options);
        },

        info: function (message, duration, options) {
            this.alert('info', message, duration, options);
        },

        warning: function (message, duration, options) {
            var newOptions = _.extend({ onceADay: true }, options);
            this.alert('warning', message, duration, newOptions);
        },

        isShowing: function() {
            return notie.is
        },

        // Постоянно ли скрыт этот алерт (localStorage). Нужно showAlerts, чтобы
        // пропустить скрытый верхний алерт и показать следующий по приоритету.
        isPersistDismissed: function (alertId) {
            return _isPersist(alertId) && _isDismissed(alertId);
        },

        // Runs only first time
        initElements: function () {
            this.$body = $('body');
            this.$alert = $('#notie-alert-outer');


            if (!this.$body.find('.js-alert-background').length) {
                this.$body.append('<div class="b-alert-background js-alert-background"></div>');
                this.$background = $('.js-alert-background');
            }

            if (!this.$body.find('.js-alert-close').length) {
                this.$alert.append('<i class="fa fa-times b-alert-close js-alert-close" aria-hidden="true"></i>');
                this.$close = $('.js-alert-close');
            }

            this.firstTime = false;
        },

        alert: function (type, message, duration, options) {
            this.options = options || {};
            var hideClose = typeof options.hideClose == 'function' ? options.hideClose() : options.hideClose;
            // Постоянно скрытые (localStorage) алерты про баны/модерацию — не показываем
            if (this.options.alertId && _isPersist(this.options.alertId) && _isDismissed(this.options.alertId)) {
                return false;
            }
            // If alert should be shown once a day
            if (this.options.onceADay) {
                if (this.options.alertId) {
                    if ($.cookie("LPT_alert_" + this.options.alertId) === 'true') {
                        return false;
                    } else {
                        //$.cookie("LPT_alert_" + options.alertId, true, { expires: 1, path: '/' });
                    }
                } else {
                    console.warn('Укажите "alertId" если хотите показывать сообщение 1 раз в день');
                    return false;
                }
            }

            if (notie.isShowing()) {
                this.$alert.removeClass('prevent-close');
                this.hide();
            }

            if (this.firstTime) {
                this.initElements();
            }

            if(typeof options.id !== 'undefined'){
                this.$alert.addClass(options.id);
            }

            if (!message) {
                app.message.error('Нет сообщения алерта !');
                return false;
            }

            this.$alert.find('#notie-alert-text').html(message);
                // If alert contains button with page redirection
                if (options.buttons && options.buttons.length) {
                    this.$alert.addClass('with-button');
                    this.$alert.find('.b-alert-action-button').remove();
                    _.each(options.buttons, function (button) {
                        if (!button.text) {
                            app.message.error('Не указан текст кнопки алерта !');
                        }

                        if(typeof button.href !== 'undefined'){
                            var onclick = '';
                            if(typeof button.parameter !== 'undefined'){
                                onclick = ' onclick="javascript:{window.'+button.parameter+'=1;}" ';
                            }
                            var $btn = $('<a href="'+button.href+'" class="btn b-alert-action-button" '+onclick+'>'+button.text+'</a>');
                        }else{
                            var $btn = $('<button class="btn b-alert-action-button js-button">' + button.text + '</button>');
                        }

                        if (button.style) {
                            $btn.css(button.style);
                        }
                        if (button.data) {
                            $btn.addClass('js-modal').data(button.data);
                        }
                        if (button.target) {
                            $btn.attr('target', button.target);
                        }

                        if (button.className) {
                            $btn.addClass(button.className);
                        }
                        if (options.alertId == 'unitedNumber') {
                            $btn.data('project', app.currentProjectId)
                        }

                        this.$alert.append($btn);
                    }.bind(this));

                    this.$alert.find('.js-button').off('click').on('click', this.showModal.bind(this));

                    // Кнопка «Больше не показывать» — постоянная кука + localStorage, скрываем
                    this.$alert.find('.js-alert-dismiss-forever').off('click').on('click', function (e) {
                        if (e && e.preventDefault) { e.preventDefault(); }
                        this.setCookie(this.options);
                        _markDismissed(this.options && this.options.alertId);
                        this.hide();
                    }.bind(this));
                }

                // If text is too long then we resize the font to fit in one line
                if (options.fontSize) {
                    this.$alert.find('#notie-alert-text').css('font-size', options.fontSize + 'px');
                }

                this.$alert.find('.js-alert-close').toggle(!hideClose);

            // Classes, that will be applied to the alert element
            this.bodyClass = 'visible-alert system-alert-' + type;

            this.$body.addClass(this.bodyClass);

            notie.alert(type, message, duration);

            if (type === 'error' || type === 'warning') {
                this.$alert.addClass('prevent-close');
                //if (type === 'warning') {
                    this.$close.click(this.hideWarning.bind(this));
                //}
            } else {
                this.$background.click(this.hide.bind(this));
                this.$alert.click(this.hide.bind(this));
            }

            if (duration) {
                this.hideTimeout = setTimeout(this.hide.bind(this), duration * 1000);
            }
        },

        hideWarning: function () {
            if (this.$alert) {
                this.$alert.removeClass('prevent-close');
                this.setCookie(this.options);
                // Крестик на алертах про баны/модерацию/верификацию = скрыть НАВСЕГДА (localStorage)
                _markDismissed(this.options && this.options.alertId);
                this.hide();
            }
        },

        showModal: function (event) {
            var data = $(event.currentTarget).data();
            if(data && data.url) {
                Backbone.history.navigate(data.url, true);
            }
            ModalsFactory.create(data.modal, function (Modal) {
                app.regionModal.show(new Modal({
                    modalData: data
                }));
            });
            this.setCookie(this.options);
        },

        hide: function () {
            clearTimeout(this.hideTimeout);
            notie.alertHide();
            this.$body.removeClass(this.bodyClass);
            this.$background.off();
            //this.setCookie(this.options);
            if (this.options && this.options.button) {
                this.$alert.removeClass('with-button').find('.js-button').remove();
            }
            if (this.$close) {
                this.$close.off();
            }
            if (this.scrollDisabled) {
                this.enableScroll();
                delete this.scrollDisabled;
            }
        },

        setCookie: function(options) {
            if(options && options.onceADay && options.alertId) {
                var exp = (options.cookieExpires && options.cookieExpires > 0) ? options.cookieExpires : 1;
                $.cookie("LPT_alert_" + options.alertId, true, { expires: exp, path: '/' });
            }
        },

        queue: function (alert) {
            this.inQueue.push(alert);
        },

        enableScroll: function () {
            this.$body.attr('style', '');
        },

        disableScroll: function () {
            this.$body.attr('style', 'overflow:hidden');
        }
    }
});
